import { qs } from '@fluorescent/dom';
import Delegate from 'ftdomdelegate';
import { emit } from '@/neon/events';

const selectors = {
  drawerTrigger: '[data-store-availability-drawer-trigger]',
  drawer: '[data-store-availability-drawer]',
  productTitle: '[data-store-availability-product-title]',
  storeList: '[data-store-availability-list-content]',
};

const storeAvailability = (container, product, variant) => {
  let storeList = null;
  let currentVariant = variant;

  const delegate = new Delegate(container);

  const _clickHandler = e => {
    e.preventDefault();

    emit('availability:showMore', () => ({
      product,
      variant: currentVariant,
      storeList,
    }));
  };

  const update = variant => {
    currentVariant = variant;
    const variantSectionUrl = `${container.dataset.baseUrl}/variants/${variant.id}/?section_id=store-availability`;

    fetch(variantSectionUrl)
      .then(response => {
        return response.text();
      })
      .then(storeAvailabilityHTML => {
        container.innerHTML = '';
        if (storeAvailabilityHTML.trim() === '') return;

        // Remove section wrapper that throws nested sections error
        container.innerHTML = storeAvailabilityHTML;
        container.innerHTML = container.firstElementChild.innerHTML;

        storeList = qs(selectors.storeList, container);
      });
  };

  // Intialize
  update(variant);
  delegate.on('click', selectors.drawerTrigger, _clickHandler);

  const unload = () => {
    container.innerHTML = '';
  };

  return { unload, update };
};

export default storeAvailability;
